export default __webpack_public_path__ + "static/ibcomputersciencevarun-4b027b87b9f874a12ed3c70d09df57f3.jpeg";